import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, DownloadIcon, RefreshCwIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.upreferr.com/cart/44596916224135:1';
export function FinalCTA() {
  const goToCheckout = () => {
    window.location.href = CHECKOUT_URL;
  };
  return <section className="py-20 lg:py-32 bg-[#1A3320]" data-id="element-28">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto text-center" data-id="element-30">
          <div className="inline-flex items-center gap-2 bg-[#C9A84C] text-black px-4 py-2 rounded-full text-xs font-bold uppercase mb-6" data-id="element-31">
            OFERTA DE LANZAMIENTO
          </div>

          <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-32">
            Recupera el control de tu cuerpo hoy mismo
          </h2>

          <p className="text-xl text-white italic mb-8" data-id="element-33">
            No permitas que otro mes de frustración pase mientras tu metabolismo
            sigue bloqueado.
          </p>

          <p className="text-white mb-6" data-id="element-34">
            📖 eBook Completo ($37) + 📋 Protocolo 21 Días ($27) + ✅ Checklists
            ($17)
          </p>

          <p className="text-2xl text-[#C9A84C] font-bold mb-4" data-id="element-35">
            Todo por solo $8.49 USD hoy
          </p>

          <div className="flex items-baseline justify-center gap-4 mb-4" data-id="element-36">
            <span className="text-gray-400 line-through text-xl" data-id="element-37">$81.00</span>
            <span className="text-[#C9A84C] text-6xl font-bold" data-id="element-38">$8.49</span>
            <span className="text-white text-xl" data-id="element-39">USD</span>
          </div>

          <p className="text-[#C2856A] text-sm font-semibold mb-8" data-id="element-40">
            ⏰ Precio de lanzamiento · Sube a $27 pronto
          </p>

          <button onClick={goToCheckout} className="w-full lg:w-auto bg-[#C9A84C] text-black px-12 py-6 rounded-full text-xl font-bold uppercase hover:brightness-110 transition-all shadow-2xl mb-8" data-id="element-41">
            SÍ, QUIERO MI PROTOCOLO HORMONAL AHORA →
          </button>

          <div className="flex flex-wrap justify-center gap-8 mb-8" data-id="element-42">
            <div className="flex items-center gap-2 text-white text-sm" data-id="element-43">
              <LockIcon className="w-5 h-5" data-id="element-44" />
              <span data-id="element-45">Pago Seguro Shopify</span>
            </div>
            <div className="flex items-center gap-2 text-white text-sm" data-id="element-46">
              <DownloadIcon className="w-5 h-5" data-id="element-47" />
              <span data-id="element-48">Descarga Inmediata</span>
            </div>
            <div className="flex items-center gap-2 text-white text-sm" data-id="element-49">
              <RefreshCwIcon className="w-5 h-5" data-id="element-50" />
              <span data-id="element-51">Garantía 30 Días</span>
            </div>
          </div>

          <p className="text-xs text-gray-500" data-id="element-52">
            © 2025 Código Hormonal 40+ · codigohormonal40.com · Los resultados
            pueden variar. Este producto tiene fines informativos y no sustituye
            el consejo médico profesional.
          </p>
        </motion.div>
      </div>
    </section>;
}